module.exports = __webpack_public_path__ + "static/img/blog_3.a620217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/blog/blog_3.jpg
// module id = 6ype
// module chunks = 1